import { create } from 'zustand';
import type { OrdrWsConnectionState, WebSocketMessage } from '../utils/OrdrWebSocketClient';

// Keep the debug log bounded so a long-running KDS shift doesn't grow memory.
const MESSAGE_CAP = 200;

type OrdrWebSocketState = {
  connectionState: OrdrWsConnectionState;
  messages: WebSocketMessage[];
  setConnectionState: (state: OrdrWsConnectionState) => void;
  addMessage: (msg: WebSocketMessage) => void;
  reset: () => void;
};

export const useOrdersWebSocketStore = create<OrdrWebSocketState>((set) => ({
  connectionState: 'disconnected',
  messages: [],

  setConnectionState: (connectionState) => set({ connectionState }),

  addMessage: (msg) =>
    set((state) => ({
      messages: [msg, ...state.messages].slice(0, MESSAGE_CAP),
    })),

  reset: () => set({ connectionState: 'disconnected', messages: [] }),
}));
